<template>
  <!-- Show Splash Screen while resetting vuex and local store-->
  <SplashScreen v-if="resetCacheLoading" />

  <template v-else>
    <!-- TODO: Remove the MobileLoginScreen and MobileLoginLayout from the repo if the SSOLogin is final -->
    <!-- Login Screen -->
    <LoginLayout
      v-if="!otpRequired"
      class="login-layout__login"
      :title="t('Login to {merchantBrand}', { merchantBrand })"
      :subtitle="
        t('Sign in into {siteSetting} {merchantBrand} account', {
          siteSetting,
          merchantBrand,
        })
      "
      showLogo
    >
      <template #body>
        <LoginForm @onOtpRequired="onOtpRequired" />
      </template>
    </LoginLayout>

    <!-- Login OTP Screen -->
    <LoginOtp v-else @goBack="goBack" />

    <CookieConsent />
  </template>
</template>

<style lang="scss">
.login-layout {
  &__login {
    .login-layout__form {
      padding: $padding-xlg;
      margin-bottom: $non-auth-layout-margin;
      z-index: $non-auth-z-index;
      background: $non-auth-background;
      width: $non-auth-width;
      margin-top: $non-auth-layout-margin;
      border: 1px solid $non-auth-border-color;
      border-radius: $border-radius-base;
    }

    // IPAD, mobile screens and below
    @media screen and (max-width: $screen-lg) {
      .login-layout__form {
        padding: $overview-card-padding;
      }
    }

    @media screen and (max-width: $screen-sm) {
      .login-layout__form {
        padding: $margin-xs;
        margin-top: unset;
        margin-bottom: unset;
        width: 100%;
        border-color: transparent;
      }
    }
  }
}
</style>

<script lang="ts">
import { computed, defineComponent, ref } from "vue";
import { useI18n } from "vue-i18n";
import LoginLayout from "@/shared/components/layouts/LoginLayout.vue";
import LoginOtp from "@/shared/views/LoginOTP.vue";
import LoginForm from "@/shared/components/forms/LoginForm.vue";
import { windowSizeSimpleStore } from "@/shared/store/simpleStore/windowSizeData";
import SplashScreen from "@/shared/components/SplashScreen.vue";
import useResetCache from "@/shared/composables/useResetCache";
import { useStore } from "vuex";
import { config } from "@/shared/utils/config";
import { loginSimpleStore } from "@/shared/store/simpleStore/loginData";
import CookieConsent from "@motomedialab/cookie-consent";

export default defineComponent({
  setup() {
    const t = useI18n().t;
    const store = useStore();
    const otpRequired = ref(false);
    const isMobileScreen = computed(() => windowSizeSimpleStore.isMobile);

    // TODO: Find a way to show splash screen while resetting cache properly
    const isTokenExisting = computed(() => store.state.userInfo.token);

    const { resetCacheLoading, resetCache } = useResetCache();

    // if token exists, call the reset cache to show the splash screen while resetting cache
    if (isTokenExisting.value) {
      (async () => {
        await resetCache();
      })();
    }

    const onOtpRequired = (isOtpRequired) => {
      otpRequired.value = isOtpRequired;
    };

    return {
      t,
      otpRequired,
      goBack: () => {
        // reset when going back since login details are blank
        loginSimpleStore.resetStore();
        otpRequired.value = false;
      },
      onOtpRequired,
      isMobileScreen,
      resetCacheLoading,
      merchantBrand: config.merchantBrand,
      siteSetting:
        config.siteSettings == "corporate" ? t("business") : t("personal"),
    };
  },
  components: {
    LoginLayout,
    LoginForm,
    LoginOtp,
    SplashScreen,
    CookieConsent,
  },
});
</script>
